{
  "catalogId": "safetyqr_kit_packaging",
  "catalogVersion": "2026-03-30.phase2",
  "lastReviewedOn": "2026-03-30",
  "sourceSpecPath": "gg/agent-outputs/safetyqr-kit-packaging-implementation-spec.md",
  "openDecisions": [
    {
      "id": "rider_role_differentiation",
      "title": "Rider role differentiation",
      "status": "pending_approval",
      "summary": "The rider kit keeps both stickers in the shared help path until a differentiated incident role is explicitly approved."
    },
    {
      "id": "rider_identifier_line_rule",
      "title": "Rider identifier line rule",
      "status": "pending_approval",
      "summary": "The rider identifier line must not reuse the car card-number or sticker-number convention without approval."
    }
  ],
  "productFamilies": [
    {
      "productFamily": "vehicle_safety_qr",
      "displayName": "Vehicle SafetyQR",
      "approvalStatus": "approved",
      "notificationPolicyId": "safetyqr.notification.vehicle.default.v1",
      "variants": [
        {
          "kitVariant": "car_safety_kit",
          "displayName": "Car Safety Kit",
          "productFamily": "vehicle_safety_qr",
          "vehicleClass": "four_wheeler",
          "solutionCategory": null,
          "launchGate": {
            "launchable": true,
            "status": "launch_ready",
            "blockedByDecisionIds": [],
            "note": "Car Safety Kit is launch-ready for stock generation and print preparation."
          },
          "activationModel": {
            "activationScope": "kit",
            "preferredInitiationRole": null,
            "sharedActivation": true,
            "siblingActivationBehavior": "activate_entire_kit"
          },
          "printTemplateId": "safetyqr.print.vehicle.car.v1",
          "reportTemplateId": "safetyqr.report.vehicle_incident.v1",
          "preActivationRoutePolicy": "register_kit",
          "tags": [
            {
              "slot": "sticker_a",
              "role": "help_primary",
              "placement": {
                "status": "approved",
                "value": "car windshield"
              },
              "sizeMm": {
                "status": "approved",
                "width": 50,
                "height": 50
              },
              "primaryCopy": {
                "status": "approved",
                "value": "SCAN TO HELP"
              },
              "icon": {
                "status": "not_applicable",
                "token": null
              },
              "identifierLine": {
                "status": "approved",
                "token": "card_number",
                "label": "card number"
              },
              "printSlot": "primary",
              "printTemplateId": "safetyqr.print.vehicle.car.v1",
              "reportTemplateId": "safetyqr.report.vehicle_incident.v1",
              "postActivationRoutePolicy": {
                "status": "approved",
                "token": "report_incident_direct"
              }
            },
            {
              "slot": "sticker_b",
              "role": "incident_secondary",
              "placement": {
                "status": "approved",
                "value": "car dashboard"
              },
              "sizeMm": {
                "status": "approved",
                "width": 35,
                "height": 35
              },
              "primaryCopy": {
                "status": "approved",
                "value": "REPORT INCIDENT"
              },
              "icon": {
                "status": "not_applicable",
                "token": null
              },
              "identifierLine": {
                "status": "approved",
                "token": "sticker_number",
                "label": "sticker number"
              },
              "printSlot": "secondary",
              "printTemplateId": "safetyqr.print.vehicle.car.v1",
              "reportTemplateId": "safetyqr.report.vehicle_incident.v1",
              "postActivationRoutePolicy": {
                "status": "approved",
                "token": "report_incident_direct"
              }
            }
          ]
        },
        {
          "kitVariant": "riders_safety_kit",
          "displayName": "Riders Safety Kit",
          "productFamily": "vehicle_safety_qr",
          "vehicleClass": "two_wheeler",
          "solutionCategory": null,
          "launchGate": {
            "launchable": true,
            "status": "launch_ready",
            "blockedByDecisionIds": [],
            "note": "Riders Safety Kit is launch-ready for stock generation and print preparation."
          },
          "activationModel": {
            "activationScope": "kit",
            "preferredInitiationRole": null,
            "sharedActivation": true,
            "siblingActivationBehavior": "activate_entire_kit"
          },
          "printTemplateId": "safetyqr.print.vehicle.rider.v1",
          "reportTemplateId": "safetyqr.report.rider_help_incident.v1",
          "preActivationRoutePolicy": "register_kit",
          "tags": [
            {
              "slot": "sticker_a",
              "role": "help_primary",
              "placement": {
                "status": "approved",
                "value": "helmet"
              },
              "sizeMm": {
                "status": "approved",
                "width": 35,
                "height": 35
              },
              "primaryCopy": {
                "status": "approved",
                "value": "SCAN TO HELP"
              },
              "icon": {
                "status": "approved",
                "token": "helmet"
              },
              "identifierLine": {
                "status": "tbd",
                "token": null,
                "label": null
              },
              "printSlot": "primary",
              "printTemplateId": "safetyqr.print.vehicle.rider.v1",
              "reportTemplateId": "safetyqr.report.rider_help_incident.v1",
              "postActivationRoutePolicy": {
                "status": "tbd",
                "token": "vehicle_rider_shared_help_incident_pending_approval"
              }
            },
            {
              "slot": "sticker_b",
              "role": "help_secondary",
              "placement": {
                "status": "approved",
                "value": "phone case back"
              },
              "sizeMm": {
                "status": "approved",
                "width": 25,
                "height": 25
              },
              "primaryCopy": {
                "status": "approved",
                "value": "SCAN TO HELP"
              },
              "icon": {
                "status": "approved",
                "token": "phone"
              },
              "identifierLine": {
                "status": "tbd",
                "token": null,
                "label": null
              },
              "printSlot": "secondary",
              "printTemplateId": "safetyqr.print.vehicle.rider.v1",
              "reportTemplateId": "safetyqr.report.rider_help_incident.v1",
              "postActivationRoutePolicy": {
                "status": "tbd",
                "token": "vehicle_rider_shared_help_incident_pending_approval"
              }
            }
          ]
        }
      ]
    },
    {
      "productFamily": "personal_safety_qr",
      "displayName": "Personal SafetyQR",
      "approvalStatus": "approved",
      "notificationPolicyId": "safetyqr.notification.personal.default.v1",
      "variants": [
        {
          "kitVariant": "students_safety_qr",
          "displayName": "Students SafetyQR",
          "productFamily": "personal_safety_qr",
          "vehicleClass": null,
          "solutionCategory": "students",
          "launchGate": {
            "launchable": true,
            "status": "launch_ready",
            "blockedByDecisionIds": [],
            "note": "Students SafetyQR is launch-ready on the shared kit architecture and routes both tags through the existing public report surface after activation."
          },
          "activationModel": {
            "activationScope": "kit",
            "preferredInitiationRole": null,
            "sharedActivation": true,
            "siblingActivationBehavior": "activate_entire_kit"
          },
          "printTemplateId": "safetyqr.print.personal.students.v1",
          "reportTemplateId": "safetyqr.report.student_safety_check.v1",
          "preActivationRoutePolicy": "register_kit",
          "tags": [
            {
              "slot": "sticker_a",
              "role": "primary_tag",
              "placement": {
                "status": "approved",
                "value": "school bag or backpack"
              },
              "sizeMm": {
                "status": "approved",
                "width": 35,
                "height": 35
              },
              "primaryCopy": {
                "status": "approved",
                "value": "STUDENT SAFETY"
              },
              "icon": {
                "status": "not_applicable",
                "token": null
              },
              "identifierLine": {
                "status": "approved",
                "token": "kit_number",
                "label": "kit number"
              },
              "printSlot": "primary",
              "printTemplateId": "safetyqr.print.personal.students.v1",
              "reportTemplateId": "safetyqr.report.student_safety_check.v1",
              "postActivationRoutePolicy": {
                "status": "approved",
                "token": "report_incident_direct"
              }
            },
            {
              "slot": "sticker_b",
              "role": "secondary_tag",
              "placement": {
                "status": "approved",
                "value": "notebook, bottle, or ID holder"
              },
              "sizeMm": {
                "status": "approved",
                "width": 25,
                "height": 25
              },
              "primaryCopy": {
                "status": "approved",
                "value": "SCAN FOR HELP"
              },
              "icon": {
                "status": "not_applicable",
                "token": null
              },
              "identifierLine": {
                "status": "approved",
                "token": "tag_number",
                "label": "tag number"
              },
              "printSlot": "secondary",
              "printTemplateId": "safetyqr.print.personal.students.v1",
              "reportTemplateId": "safetyqr.report.student_safety_check.v1",
              "postActivationRoutePolicy": {
                "status": "approved",
                "token": "report_incident_direct"
              }
            }
          ]
        },
        {
          "kitVariant": "women_safety_qr",
          "displayName": "Women SafetyQR",
          "productFamily": "personal_safety_qr",
          "vehicleClass": null,
          "solutionCategory": "women",
          "launchGate": {
            "launchable": true,
            "status": "launch_ready",
            "blockedByDecisionIds": [],
            "note": "Women SafetyQR is launch-ready and reuses the same kit-backed public report routing as the vehicle variants."
          },
          "activationModel": {
            "activationScope": "kit",
            "preferredInitiationRole": null,
            "sharedActivation": true,
            "siblingActivationBehavior": "activate_entire_kit"
          },
          "printTemplateId": "safetyqr.print.personal.women.v1",
          "reportTemplateId": "safetyqr.report.women_safety_assistance.v1",
          "preActivationRoutePolicy": "register_kit",
          "tags": [
            {
              "slot": "sticker_a",
              "role": "primary_tag",
              "placement": {
                "status": "approved",
                "value": "phone case or lanyard"
              },
              "sizeMm": {
                "status": "approved",
                "width": 25,
                "height": 25
              },
              "primaryCopy": {
                "status": "approved",
                "value": "WOMEN SAFETY"
              },
              "icon": {
                "status": "not_applicable",
                "token": null
              },
              "identifierLine": {
                "status": "approved",
                "token": "kit_number",
                "label": "kit number"
              },
              "printSlot": "primary",
              "printTemplateId": "safetyqr.print.personal.women.v1",
              "reportTemplateId": "safetyqr.report.women_safety_assistance.v1",
              "postActivationRoutePolicy": {
                "status": "approved",
                "token": "report_incident_direct"
              }
            },
            {
              "slot": "sticker_b",
              "role": "secondary_tag",
              "placement": {
                "status": "approved",
                "value": "handbag, wallet, or keychain"
              },
              "sizeMm": {
                "status": "approved",
                "width": 25,
                "height": 25
              },
              "primaryCopy": {
                "status": "approved",
                "value": "SCAN FOR HELP"
              },
              "icon": {
                "status": "not_applicable",
                "token": null
              },
              "identifierLine": {
                "status": "approved",
                "token": "tag_number",
                "label": "tag number"
              },
              "printSlot": "secondary",
              "printTemplateId": "safetyqr.print.personal.women.v1",
              "reportTemplateId": "safetyqr.report.women_safety_assistance.v1",
              "postActivationRoutePolicy": {
                "status": "approved",
                "token": "report_incident_direct"
              }
            }
          ]
        },
        {
          "kitVariant": "elderly_safety_qr",
          "displayName": "Elderly SafetyQR",
          "productFamily": "personal_safety_qr",
          "vehicleClass": null,
          "solutionCategory": "elderly",
          "launchGate": {
            "launchable": true,
            "status": "launch_ready",
            "blockedByDecisionIds": [],
            "note": "Elderly SafetyQR is launch-ready and keeps both stickers on the shared kit-backed assistance route after activation."
          },
          "activationModel": {
            "activationScope": "kit",
            "preferredInitiationRole": null,
            "sharedActivation": true,
            "siblingActivationBehavior": "activate_entire_kit"
          },
          "printTemplateId": "safetyqr.print.personal.elderly.v1",
          "reportTemplateId": "safetyqr.report.elderly_assistance.v1",
          "preActivationRoutePolicy": "register_kit",
          "tags": [
            {
              "slot": "sticker_a",
              "role": "primary_tag",
              "placement": {
                "status": "approved",
                "value": "walking aid, phone, or ID pouch"
              },
              "sizeMm": {
                "status": "approved",
                "width": 30,
                "height": 30
              },
              "primaryCopy": {
                "status": "approved",
                "value": "ELDER CARE"
              },
              "icon": {
                "status": "not_applicable",
                "token": null
              },
              "identifierLine": {
                "status": "approved",
                "token": "kit_number",
                "label": "kit number"
              },
              "printSlot": "primary",
              "printTemplateId": "safetyqr.print.personal.elderly.v1",
              "reportTemplateId": "safetyqr.report.elderly_assistance.v1",
              "postActivationRoutePolicy": {
                "status": "approved",
                "token": "report_incident_direct"
              }
            },
            {
              "slot": "sticker_b",
              "role": "secondary_tag",
              "placement": {
                "status": "approved",
                "value": "wallet, medicine pouch, or bag"
              },
              "sizeMm": {
                "status": "approved",
                "width": 25,
                "height": 25
              },
              "primaryCopy": {
                "status": "approved",
                "value": "SCAN FOR HELP"
              },
              "icon": {
                "status": "not_applicable",
                "token": null
              },
              "identifierLine": {
                "status": "approved",
                "token": "tag_number",
                "label": "tag number"
              },
              "printSlot": "secondary",
              "printTemplateId": "safetyqr.print.personal.elderly.v1",
              "reportTemplateId": "safetyqr.report.elderly_assistance.v1",
              "postActivationRoutePolicy": {
                "status": "approved",
                "token": "report_incident_direct"
              }
            }
          ]
        }
      ]
    },
    {
      "productFamily": "site_safety_qr",
      "displayName": "Site SafetyQR",
      "approvalStatus": "approved",
      "notificationPolicyId": "safetyqr.notification.site.default.v1",
      "variants": [
        {
          "kitVariant": "plantations_safety_qr",
          "displayName": "SafetyQR for Plantations",
          "productFamily": "site_safety_qr",
          "vehicleClass": null,
          "solutionCategory": "plantations",
          "launchGate": {
            "launchable": true,
            "status": "launch_ready",
            "blockedByDecisionIds": [],
            "note": "Plantations SafetyQR ships as a five-sticker outdoor site kit. Every sticker shows SCAN TO ALERT with the card ID number, and the first successful activation prepares the full kit for later zone-based reporting."
          },
          "activationModel": {
            "activationScope": "kit",
            "preferredInitiationRole": null,
            "sharedActivation": true,
            "siblingActivationBehavior": "activate_entire_kit"
          },
          "printTemplateId": "safetyqr.print.site.plantations.v1",
          "reportTemplateId": "safetyqr.report.plantations.v1",
          "preActivationRoutePolicy": "register_kit",
          "tags": [
            {
              "slot": "sticker_a",
              "role": "zone_tag_1",
              "placement": {
                "status": "approved",
                "value": "site zone or deployment point"
              },
              "sizeMm": {
                "status": "approved",
                "width": 60,
                "height": 60
              },
              "primaryCopy": {
                "status": "approved",
                "value": "SCAN TO ALERT"
              },
              "icon": {
                "status": "approved",
                "token": "alert"
              },
              "identifierLine": {
                "status": "approved",
                "token": "card_number",
                "label": "card ID number"
              },
              "printSlot": "tag_1",
              "printTemplateId": "safetyqr.print.site.plantations.v1",
              "reportTemplateId": "safetyqr.report.plantations.v1",
              "postActivationRoutePolicy": {
                "status": "approved",
                "token": "report_incident_direct"
              }
            },
            {
              "slot": "sticker_b",
              "role": "zone_tag_2",
              "placement": {
                "status": "approved",
                "value": "site zone or deployment point"
              },
              "sizeMm": {
                "status": "approved",
                "width": 60,
                "height": 60
              },
              "primaryCopy": {
                "status": "approved",
                "value": "SCAN TO ALERT"
              },
              "icon": {
                "status": "approved",
                "token": "alert"
              },
              "identifierLine": {
                "status": "approved",
                "token": "card_number",
                "label": "card ID number"
              },
              "printSlot": "tag_2",
              "printTemplateId": "safetyqr.print.site.plantations.v1",
              "reportTemplateId": "safetyqr.report.plantations.v1",
              "postActivationRoutePolicy": {
                "status": "approved",
                "token": "report_incident_direct"
              }
            },
            {
              "slot": "sticker_c",
              "role": "zone_tag_3",
              "placement": {
                "status": "approved",
                "value": "site zone or deployment point"
              },
              "sizeMm": {
                "status": "approved",
                "width": 60,
                "height": 60
              },
              "primaryCopy": {
                "status": "approved",
                "value": "SCAN TO ALERT"
              },
              "icon": {
                "status": "approved",
                "token": "alert"
              },
              "identifierLine": {
                "status": "approved",
                "token": "card_number",
                "label": "card ID number"
              },
              "printSlot": "tag_3",
              "printTemplateId": "safetyqr.print.site.plantations.v1",
              "reportTemplateId": "safetyqr.report.plantations.v1",
              "postActivationRoutePolicy": {
                "status": "approved",
                "token": "report_incident_direct"
              }
            },
            {
              "slot": "sticker_d",
              "role": "zone_tag_4",
              "placement": {
                "status": "approved",
                "value": "site zone or deployment point"
              },
              "sizeMm": {
                "status": "approved",
                "width": 60,
                "height": 60
              },
              "primaryCopy": {
                "status": "approved",
                "value": "SCAN TO ALERT"
              },
              "icon": {
                "status": "approved",
                "token": "alert"
              },
              "identifierLine": {
                "status": "approved",
                "token": "card_number",
                "label": "card ID number"
              },
              "printSlot": "tag_4",
              "printTemplateId": "safetyqr.print.site.plantations.v1",
              "reportTemplateId": "safetyqr.report.plantations.v1",
              "postActivationRoutePolicy": {
                "status": "approved",
                "token": "report_incident_direct"
              }
            },
            {
              "slot": "sticker_e",
              "role": "zone_tag_5",
              "placement": {
                "status": "approved",
                "value": "site zone or deployment point"
              },
              "sizeMm": {
                "status": "approved",
                "width": 60,
                "height": 60
              },
              "primaryCopy": {
                "status": "approved",
                "value": "SCAN TO ALERT"
              },
              "icon": {
                "status": "approved",
                "token": "alert"
              },
              "identifierLine": {
                "status": "approved",
                "token": "card_number",
                "label": "card ID number"
              },
              "printSlot": "tag_5",
              "printTemplateId": "safetyqr.print.site.plantations.v1",
              "reportTemplateId": "safetyqr.report.plantations.v1",
              "postActivationRoutePolicy": {
                "status": "approved",
                "token": "report_incident_direct"
              }
            }
          ]
        }
      ]
    }
  ]
}
